import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMutation } from 'react-query';
import SaveConfigurationService from './SaveConfigurationService';
import { changeIsSummaryOpened, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages, Language } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function DownloadPdfService() {
    const { promotionSlug, currentUnit, currentLanguage } = useSelector(state => state.configurator);
    const saveConfigurationMutation = SaveConfigurationService();
    const userMutation = UserService();
    const dispatch = useDispatch();

    const callback = (code) => {
        const unitId = currentUnit !== null ? currentUnit.id : 0;
        let requestBudgetUrl = `${EndPoints.RequestBudget}/${promotionSlug}/unit/${unitId}/code/${code}/request-budget`;
        if (currentLanguage !== Language.es) {
            requestBudgetUrl = `${requestBudgetUrl}?language=${currentLanguage}`;
        }
        const config = {
            headers: {
                [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
            },
        };
        axios
            .post(requestBudgetUrl, {}, config)
            .then((response) => {
                dispatch(changeIsSummaryOpened(false));
                dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetSuccess));
                userMutation.mutate({});
                // dispatch(requestBudgetComplete());
            })
            .catch((error) => {
                console.log(error);
                dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetError));
            });
    };

    return useMutation(['requestBudgetQuery'], () => {
        saveConfigurationMutation.mutate(callback);
    });
}
